import { render, staticRenderFns } from "./InfoExtra.vue?vue&type=template&id=5c1808cb&"
import script from "./InfoExtra.vue?vue&type=script&lang=js&"
export * from "./InfoExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports